import { EssCards } from '../../../types/EssCards';

export const getDefaultActiveCardId = (cards: EssCards[] | null | undefined): string | null => {
    if (!cards || cards.length === 0) {
        return null;
    }

    return cards[cards.length - 1].id;
};

export const getTabLabel = (card: EssCards | null | undefined, essLabel: string): string => {
    if (!card || card.number === undefined || card.number === null) {
        return essLabel;
    }

    return `${essLabel} ${card.number}`;
};
